//存放数据
import func from '@/script/func';
import MarkdownIt from 'markdown-it';
import hljs from 'highlight.js';
import 'highlight.js/styles/github-dark.css';
const md = new MarkdownIt({
    html: false,
    linkify: true,
    breaks: true,
    highlight(str, lang) {
        try {
            if (lang && hljs.getLanguage(lang)) {
                return (
                    '<pre class="hljs"><code>' +
                    hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
                    '</code></pre>'
                );
            }
            const { value } = hljs.highlightAuto(str);
            return '<pre class="hljs"><code>' + value + '</code></pre>';
        } catch (e) {
            return (
                '<pre class="hljs"><code>' +
                md.utils.escapeHtml(str) +
                '</code></pre>'
            );
        }
    },
});
function renderMarkdown(text) {
    if (!text) return '';
    return md.render(text);
}
const state = {
    info: {
        __process: 1,
        __js: "/api/index.js",
        __process_id: "",
    },
    message: '',
    sendStatus: 0, // 0: 未发送 1: 发送中 2: 发送完成 3.点击停止
    nextMessageId: 1,
    messageList: [
    ],
}
//修改数据，调用方式this.$store.commit('increment', 2)
const mutations = {
    //设置进程id
    setProcessId(state, processId) {
        state.info.__process_id = processId;
    },
    setMessage(state, message) {
        state.message = message;
    },
    setSendStatus(state, sendStatus) {
        state.sendStatus = sendStatus;
    },
    setNextMessageId(state, nextMessageId) {
        state.nextMessageId = nextMessageId;
    },
    setMessageList(state, messageList) {
        state.messageList = messageList;
    },
    /** 追加一条会话消息（自动分配 id） */
    addChatMessage(state, payload) {
        const last = state.messageList[state.messageList.length - 1];
        if (last && last.role === 'toolping') {
            last.content = "工具准备完毕";
        }
        const row = {
            id: state.nextMessageId++,
            ...payload,
        };
        if (row.role === 'assistant' && row.content != null && row.html === undefined) {
            row.html = renderMarkdown(String(row.content));
        }
        state.messageList.push(row);
    },
    /** 流式增量：同 role 则拼接 content，否则新建一条 */
    appendStreamDelta(state, { role, text }) {
        const list = state.messageList;
        const last = list[list.length - 1];
        if (last && last.role === role) {
            last.content += text;
            last.html = renderMarkdown(last.content);
        } else {
            list.push({
                id: state.nextMessageId++,
                role,
                content: text,
                html: renderMarkdown(text),
            });
        }
        // console.log("---------appendStreamDelta", state.messageList);
    },
    /** 工具调用结束前更新最后一条带 tool_calls 的 assistant 文案 */
    setLastAssistantWithToolsContent(state, content) {
        const last = state.messageList[state.messageList.length - 1];
        if (last && last.role === 'assistant' && last.tool_calls) {
            last.content = content;
            last.html = renderMarkdown(String(content));
        }
    },
    setToolping(state, payload) {
        const row = {
            id: state.nextMessageId++,
            ...payload,
        };
        const last = state.messageList[state.messageList.length - 1];
        if (last && last.role === 'toolping') {
            last.content = row.content;
        } else {
            state.messageList.push(row);
        }
    },
}
//专门处理异步，调用方式：this.$store.dispatch('fetchUser')
const actions = {
    //初始化
    async init({ state, commit, rootState }) {
        let p = func.sget("process_list");
        if (p && p.api) {
            commit("setProcessId", p.api)
        } else {
            //创建线程
            let rs = await rootState.eapi.invoke("fork@create", state.info);
            if (rs.code == 1) {
                // console.log("------------rs", rs);
                let p2 = func.sget("process_list");
                if (!p2) {
                    p2 = {};
                }
                p2.api = rs.__process_id;
                func.ssave("process_list", p2)
                // console.log("---------创建进程")
                commit("setProcessId", rs.__process_id)
            } else {
                //创建进程失败
                console.warn("------------------创建子进程失败");
            }
        }
    },
    //调用进程
    async invoke({ state, commit, rootState }, payload) {
        let { action, overTime, data } = payload;
        if (overTime === undefined) {
            overTime = 20000;
        }
        let rs = await rootState.eapi.invoke(action, Object.assign(state.info, data), overTime);
        return rs;
    },
}

//state 的计算属性，像 computed，使用方式：this.$store.getters.isLogin
const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}